import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/home'


Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			redirect: '/User',
			hidden: true,
		},
		{
			path: '/login',
			name: 'login',
			component: () => import('../views/login/index'),
			hidden: true,
		},
		{
			path: '/',
			component: Home,
			redirect: '/home',
			name: 'home',
			hidden: true,
			children: [{
				path: '/home',
				component: () => import('../views/home/home')
			}]
		},
		{
			path: '/User',
			component: Home,
			name: 'User',
			children: [
				{
					path: '/User',
					component: () => import("../components/navMain/components/User")
				}, {
					path: '/AccountQuery',
					name: 'AccountQuery',
					component: () => import("../components/navMain/components/AccountQuery")
				},
				{
					path: '/AddressTranslation',
					name: 'AddressTranslation',
					component: () => import("../components/navMain/components/AddressTranslation")
				},
				{
					path: '/ContracCreate',
					name: 'ContracCreate',
					component: () => import("../components/navMain/components/ContracCreate")
				},
				{
					path: '/ContracSearch',
					name: 'ContracSearch',
					component: () => import("../components/navMain/components/ContracSearch")
				},
				{
					path: '/HashTrading',
					name: 'HashTrading',
					component: () => import("../components/navMain/components/HashTrading")
				},
				{
					path: '/InverseSolutionOfInput',
					name: 'InverseSolutionOfInput',
					component: () => import("../components/navMain/components/InverseSolutionOfInput")
				},
				{
					path: '/Json',
					name: 'Json',
					component: () => import("../components/navMain/components/Json")
				},
				{
					path: '/Node',
					name: 'Node',
					component: () => import("../components/navMain/components/Node")
				},
				{
					path: '/PublicPrivateKey',
					name: 'PublicPrivateKey',
					component: () => import("../components/navMain/components/PublicPrivateKey")
				},
				{
					path: '/SigTransfer',
					name: 'SigTransfer',
					component: () => import("../components/navMain/components/SigTransfer")
				},
				{
					path: '/Transfer',
					name: 'Transfer',
					component: () => import("../components/navMain/components/Transfer")
				},
				{
					path: '/Vote',
					name: 'Vote',
					component: () => import("../components/navMain/components/Vote")
				},
				{
					path: '/XTO',
					name: 'XTO',
					component: () => import("../components/navMain/components/XTO")
				},
				{
					path: '/AccountNumber',
					name: 'AccountNumber',
					component: () => import("../components/navMain/components/AccountNumber")
				},
				{
					path: '/Strategy',
					name: 'Strategy',
					component: () => import("../views/Strategy")
				},
				{
					path: '/TransactionSearch',
					name: ' TransactionSearch',
					component: () => import("../components/navMain/components/TransactionSearch")
				},
				{
					path: '/contract/register',
					name: 'RegistrationContract',
					component: () => import("../components/navMain/components/RegistrationContract")
				},
				{
					path: '/SDKDocking',
					name: 'SDKDocking',
					component: () => import("../views/SDKDocking/index")
				},
				{
					path: '/contractUseFile',
					name: 'contractUseFile',
					component: () => import("../views/SDKDocking/contractUseFile")
				},
				{
					path: '/platformUsageExample',
					name: 'platformUseTutorial',
					component: () => import("../views/SDKDocking/platformUseTutorial")
				},
				
				{
					path: '/SDKWallet',
					name: 'SDKWallet',
					component: () => import("../views/SDKDocking/sdkWallet")
				},

				{
					path: '/interfaceDocking',
					name: 'interfaceDocking',
					component: () => import("../views/interfaceDocking/index")
				},
				{
					path: '/contractEditor',
					name: 'contractEditor',
					component: () => import("../views/contractEditor/index")
				},
				{
					path: '/AddressComparison',
					name: 'AddressComparison',
					component: () => import("../components/navMain/components/AddressComparison")
				},
				{
					path: '/ContractReleaseCode',
					name: 'ContractReleaseCode',
					component: () => import("../components/navMain/components/ContractReleaseCode")
				},
			]
		},

	]
})
